import axios from "axios";

import { getAuthToken } from "../../authConfig";
import { addToast } from '../../../components/Toast/actions';
import * as actionTypes from "../actionTypes";
import { MY_TASKS, GROUP_TASKS } from '../../../containers/Tasks/TaskConstants';
import { OWNER, SUPER_ADMINISTRATOR } from "../../../Data/constants";
import { clientLogger } from "../../../containers/utils"

const BASE_TASKS_URL = `/api/apps/search_task?`;


export const taskStart = () => {
  return {
    type: actionTypes.TASK_START
  }
}

export const removeTaskData = () => {
  return {
    type: actionTypes.REMOVE_TASK_DATA
  }
}
export const taskSuccess = (data, taskType, page, pageSize, filter, filter_name) => {

  return {
    type: actionTypes.TASK_SUCCESS,
    tasks: data.data,
    count: data.total,
    taskType,
    page,
    processKey: filter.processDefinitionKey,
    taskTitle: filter.nameLike,
    filter_name,
    size: pageSize
  };
};

export const taskClaim = (id) => {
  return {
    type: actionTypes.TASK_CLAIM,
    id: id
  }
}

export const taskFail = (error) => {
  return {
    type: actionTypes.TASK_ERROR,
    error: error
  }
}

export const taskUpdate = (filter, process_key, appName, taskType, total, page, taskTitle) => {
  return {
    type: actionTypes.TASK_UPDATE,
    filter: filter,
    processKey: process_key,
    appName: appName,
    taskType: taskType,
    total: total,
    page: page,
    taskTitle: taskTitle

  }
}

export const taskUpdateGroup = (filter, process_key, appName, taskType, total, page, taskTitle) => {
  return {
    type: actionTypes.TASK_UPDATE_GROUP,
    filter: filter,
    processKey: process_key,
    appName: appName,
    taskType: taskType,
    total: total,
    page: page,
    taskTitle: taskTitle
  }
}


export const searchedTask = (res, taskType, searchData, page = null, filter_name) => {
  return {
    type: actionTypes.SEARCH_TASK,
    searchedTasks: res.data.data.data,
    count: res.data.data.total,
    taskType,
    searchData,
    page,
    filter_name
  }
}

export const countUpdate = (data, type) => {
  return {
    type: actionTypes.COUNT_UPDATE,
    taskCount: {
      [type]: data.data.total || 0
    },
    filter_based_count: { [type]: data.filter_base_count || 0 }
  }
}

export const clearTaskSearchResult = () => {
  return {
    type: actionTypes.CLEAR_TASK_SEARCH
  }
}

export const getUserTaskLists = (list) => {
  return {
    type: actionTypes.GET_USER_TASK_LIST,
    taskList: list
  }
}
export const getInvolvedUserGroupResult = (groups) => {
  return {
    type: actionTypes.GET_USER_INVOLVED_GROUP,
    involved_groups: groups
  }
}

export const taskError = (error) => {
  return {
    type: actionTypes.TASK_ERROR,
    error
  }
};

export const unMountTaskData = () => {
  return dispatch => {
    return dispatch(removeTaskData())
  }

}

export const getMyApps = () => async (dispatch) => {

  getAuthToken();
  dispatch(taskStart());

  try {
    const response = await axios.get("/api/apps/?is_global=true");
    return dispatch({
      type: actionTypes.TASK_APPS,
      apps: response.data.data
    });
  } catch (error) {
    return dispatch(taskError(error));
  }
};

export const getAllTaskCount = (taskTypes = [], userRole, taskType, searchData, process_key) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    getAuthToken();
    const showGroupTasks = userRole === OWNER || userRole === SUPER_ADMINISTRATOR;
    try {
      taskTypes.reduce(async (acc, type) => {
        let URL = `${BASE_TASKS_URL}start=0&size=0&`;
        let url = ""
        let Type = type
        let response = []
        if (!showGroupTasks && type !== GROUP_TASKS && type !== MY_TASKS) {
          url = `/api/apps/group_task_count?group_id=${type.id}${process_key ? `&processDefinitionKey=${process_key}` : ``}`
          Type = type.id
        } else if (!showGroupTasks && type === MY_TASKS && taskType !== MY_TASKS) {
          url = `${URL}task_type=${type}${process_key ? `&processDefinitionKey=${process_key}` : ``}`;
        } else if (showGroupTasks && type !== taskType && (type === GROUP_TASKS || type === MY_TASKS)) {
          url = `${URL}task_type=${type}${process_key ? `&processDefinitionKey=${process_key}` : ``}`;
        }
        if (url) {
          if (searchData) {
            response = await axios.post(url, { "search": true, ...searchData });
          } else {
            response = await axios.post(url, { "deletePrevFilterData": false });
          }
          dispatch({
            type: actionTypes.TASK_COUNT,
            taskCount: {
              ...acc,
              [Type]: response.data.data.total || 0
            },
            filter_based_count: { [Type]: response.data.filter_base_count || 0 }
          })
          // return {
          //   ...acc,
          //   [Type]: response.data.data.total || 0
          // }
        }
      }, {}).then(() => { return resolve() });

    } catch (error) {
      dispatch(taskError(error));
      if (error.response && error.response.status) {
        dispatch(taskFail(error.response))
        if (error.response.status !== 500) {
          dispatch(addToast('error', 'Error', error.response.data.message))
        } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
      }

      return reject(error);
    }
    return null
  })
}

export const getGroupBasedCount = (task_type, searchData, process_key) => {
  getAuthToken();
  return dispatch => {
    return new Promise((resolve, reject) => {
      const url = `/api/apps/group_task_count?group_id=${task_type}${process_key ? `&processDefinitionKey=${process_key}` : ``}`
      if (searchData) {
        axios.post(url, { "search": true, ...searchData }).then((res) => {
          dispatch(countUpdate(res.data, task_type))
          return resolve(res)
        })
      } else {
        axios.post(url, { "deletePrevFilterData": false }).then((res) => {
          dispatch(countUpdate(res.data, task_type))
          return resolve(res)
        }).catch((err) => {
          if (err.response && err.response.status) {
            dispatch(taskFail(err.response))
            if (err.response.status !== 500) {
              dispatch(addToast('error', 'Error', err.response.data.message))
            } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
          }

          return reject(err);
        })
      }
    });
  }
}

export const getAllTaskPersist = (task_type, order, sort, page = 1, pageSize, filter_name, searchData) => (
  async (dispatch) => {
    getAuthToken();
    dispatch(taskStart());
    const START = (page - 1) * pageSize;
    let taskType = task_type
    let URL = `${BASE_TASKS_URL}start=${START}&size=${pageSize}&order=${order}&sort=${sort}`;

    if (task_type === MY_TASKS || task_type === GROUP_TASKS) {
      try {
        let response = {}
        if (searchData) {
          response = await axios.post(`${URL}&task_type=${task_type}`, { "search": true, ...searchData });
        } else {
          response = await axios.post(`${URL}&task_type=${task_type}`, { "deletePrevFilterData": false });
        }
        dispatch(taskSuccess(response.data.data, taskType, page, pageSize, response.data.filterData, filter_name));
      } catch (error) {
        dispatch(taskFail(error));
      }
    } else {
      try {
        if (filter_name) {
          URL = `${URL}&filter_value=${filter_name}`;
        }
        taskType = `${task_type}@subfilter`
        let response = {}
        if (searchData) {
          response = await axios.post(`${URL}&task_type=group_tasks${task_type && `&group_id=${task_type}`}`, { "search": true, ...searchData });
        } else {
          response = await axios.post(`${URL}&task_type=group_tasks${task_type && `&group_id=${task_type}`}`, { "deletePrevFilterData": false });
        }
        dispatch(taskSuccess(response.data.data, taskType, page, pageSize, response.data.filterData, filter_name))
      } catch (error) {
        if (error.response && error.response.status) {
          dispatch(taskFail(error.response))
          if (error.response.status !== 500) {
            dispatch(addToast('error', 'Error', error.response.data.message))
          } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
        }

      }
    }
    return null
  });

export const getFilterTask = (process_key, appName, taskType, pageSize, order, sort, taskTitle = "", userRole, involved_groups, filter_name) => {

  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(taskStart())
      const page = 1
      let filteredTasktitle = taskTitle;
      if (taskType === "tasks") {
        getAuthToken()

        let url = encodeURI(`${BASE_TASKS_URL}task_type=tasks${process_key ? `&processDefinitionKey=${process_key}` : ``}&start=0&size=${pageSize}&includeProcessVariables=true&order=${order}&sort=${sort}${filteredTasktitle ? `&nameLike=${filteredTasktitle}` : ``}`)
        axios.post(url)
          .then(res => {
            const tasks = res.data.data.data;
            const total = res.data.data.total;
            dispatch(taskUpdate(tasks, process_key, appName, taskType, total, page, taskTitle))
            return resolve(res)
          }).catch((err) => {
            dispatch(taskFail(err.response))
          })
      } else {
        getAuthToken()
        let URL = ""

        if (taskType !== GROUP_TASKS) {

          URL = `&group_id=${taskType}${filter_name ? `&filter_value=${filter_name}` : ``}`;
        }
        let url = encodeURI(`${BASE_TASKS_URL}task_type=group_tasks${process_key ? `&processDefinitionKey=${process_key}` : ``}&start=0&size=${pageSize}&includeProcessVariables=true&order=${order}&sort=${sort}${filteredTasktitle ? `&nameLike=${filteredTasktitle}` : ``}${URL}`)
        axios.post(url).then(res => {
          const tasks = res.data.data.data;
          const total = res.data.data.total;
          dispatch(taskUpdateGroup(tasks, process_key, appName, taskType, total, page, taskTitle))
          return resolve(res)
        }).catch((err) => {
          if (err.response && err.response.status) {
            dispatch(taskFail(err.response))
            if (err.response.status !== 500) {
              dispatch(addToast('error', 'Error', err.response.data.message))
            } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
          }

          return reject(err);
        })
      }

    })
  }
}

export const getClaimTask = (id, history, assignee, current_task_owner, claimFailTaskRefreshHandler) => {
  return dispatch => {
    dispatch(taskStart())
    getAuthToken()
    let data = {
      action: "claim"
    }
    let url = `/tasks/${id}`;
    axios
      .post(
        `/api/proxy-bpm/tasks/${id}`, data
      )
      .then(() => {
        history.push(url);
      })
      .catch(err => {
        if (err.response && err.response.status) {
          dispatch(taskFail(err.response));
          if (err.response.status === 409) {
            dispatch(taskClaim(id));
          }
          try {
            const errorMessage = JSON.parse(err.response.data.error).message;
            dispatch(addToast('error', 'Error', errorMessage));
          } catch (error) {
            dispatch(addToast('error', 'Error', err.response.data.message));
          }
          if (err.response.status === 409) claimFailTaskRefreshHandler()
          // dispatch(taskFail(err.response))
          // dispatch(taskClaim(id))
        } else {
          dispatch(addToast('error', 'Error', err.message));
        }
        clientLogger.log({
          message: {
            error: "Failed to claim the task.",
            taskID: id,
            url: window.location.href,
            assignee: assignee,
            current_task_owner: current_task_owner.email
          }
        });
      });
  }
}

const convertDateIdentifiers = (arr,isFilterSearch)=> {
  const convertedArray = arr.map((obj) => {
    let newObj = { ...obj };
    let newObj2 = { ...obj };
    if (obj.value.includes("DATE-IDENTIFIER")) {
      const dateRange = obj.value.split("DATE-IDENTIFIER");
      newObj.operation = "greaterThanOrEquals";
      newObj.value = dateRange[0];
      newObj.type = "date";
      newObj.variableOperation = "GREATER_THAN";
      const secondDate = dateRange[1].substring(0, 10);
      newObj2 = { ...obj };
      newObj2.operation = "lessThanOrEquals";
      newObj2.value = secondDate;
      newObj2.type = "date";
      newObj2.variableOperation = "LESS_THAN";
      return [newObj, newObj2];
    }

    newObj.operation = "likeIgnoreCase";
    newObj.value =isFilterSearch ? `%${newObj.value}%` : newObj.value;
    newObj.type = "string";
    newObj.variableOperation = "LIKE_IGNORE_CASE"; 
    
    return newObj;
  }).flat();
  return convertedArray;
}


export const searchTask = (processDefinitionKey, taskType, searchData, pageSize, order, sort, page, filter_name) => {
  let URL = ""
  let start = page ? (page - 1) * pageSize : 0;
  let url = `/api/apps/search_task?${processDefinitionKey ? `processDefinitionKey=${processDefinitionKey}&` : ``}&start=${start}&size=${pageSize}&order=${order}&sort=${sort}`;
  if (taskType === MY_TASKS || taskType === GROUP_TASKS) {
    URL = `${url}&task_type=${taskType}`
  } else {
    URL = `${url}&task_type=group_tasks&group_id=${taskType}${filter_name ? `&filter_value=${filter_name}` : ``}`
  }
  let newSearchData
  if(searchData.hasOwnProperty("search_data")){
    newSearchData = {"search_data" : convertDateIdentifiers(searchData.search_data,true)}
  }else{
    newSearchData = {"search_data" : convertDateIdentifiers([searchData],false)}
  }
  
  return dispatch => {
    dispatch(taskStart())
    axios.post(URL, { "search": true, ...newSearchData })
      .then(res => {
        dispatch(searchedTask(res, taskType, newSearchData, page, filter_name))
      })
      .catch(err => {
        if (err.response && err.response.status) {
          dispatch(taskFail(err.response))
          if (err.response.status !== 500) {
            dispatch(addToast('error', 'Error', err.response.data.message))
          } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
        }
      })
  }
}

export const clearTaskSearch = () => {
  return dispatch => {
    dispatch(clearTaskSearchResult())
  }
}

export const getUserTaskList = (appId) => {
  let url = encodeURI(`/api/apps/${appId}/user_task_list`)
  return dispatch => {
    axios.get(url)
      .then(res => {
        let list = { [appId]: res.data.data }
        dispatch(getUserTaskLists(list))
      })
      .catch(err => {
        dispatch(taskFail(err.response))
      })
  }
};

export const getInvolvedUserGroup = (userId) => {
  let url = encodeURI(`/api/users/org_users/${userId}/user_involved_group`)
  return dispatch => {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(res => {
          dispatch(getInvolvedUserGroupResult(res.data.data))
          return resolve(res)
        })
        .catch(err => {
          if (err.response && err.response.status) {
            dispatch(taskFail(err.response))
            if (err.response.status !== 500) {
              dispatch(addToast('error', 'Error', err.response.data.message))
            } else dispatch(addToast('error', 'Error', 'Something went wrong!'))
          }

          return reject(err);

        })
    });
  }
}

/* TODO: Temporary fix. This is the check to verify that the user who is task assignee can only take action on the task. */

export const getTaskAction = (id, history, assignee, current_task_owner) => {
  return dispatch => {
    getAuthToken()
    let url = `/tasks/${id}`;
    let message = "You cannot take action on this task as this task is not assigned to you. Contact your System Administrator"
    if (assignee === current_task_owner) {
      history.push(url)
      // console.log("url====>",url);
      // window.open("/org"+url, '_blank');
    } else {
      dispatch(addToast('error', 'Error', message))
      clientLogger.log({
        message: {
          error: "This user tried to take action on the task which is not assigned to him.",
          taskID: id,
          url: window.location.href,
          assignee: assignee,
          current_task_owner: current_task_owner
        }
      });
    }
  }
}

/* TODO: This is the extra check we are adding due to some folks can claim and able to complete the task which does not even belongs to their groups.
This will be the temporary fix & once we get the actual reasone for this problem we should remove this. */

export const claimTask = (id, history, assignee, current_task_owner, claimFailTaskRefreshHandler) => {
  return dispatch => {
    getAuthToken()
    let groups_data = []
    let check_list = []
    let url = `/api/proxy-bpm/task/${id}/identity`
    let message = 'You can not claim this task as this task is not assigned to your group. Contact your System Administrator'
    axios
      .get(
        url
      )
      .then((res) => {
        groups_data = res.data.data
        if (groups_data) {
          check_list = groups_data.map((group_data) => {
            if (group_data.group === null) {
              return true
            }
            let group_flag = false
            current_task_owner.involved_groups.forEach((group) => {
              if(group_data.group === group.id || group_data.group === group.key) {
               group_flag = true
              }
            })
            return group_flag
          });
        }
        if (check_list.includes(false)) {
          dispatch(addToast('error', 'Error', message))
          clientLogger.log({
            message: {
              error: "This task does not belongs to this user's group",
              taskID: id,
              url: window.location.href,
              assignee: assignee,
              current_task_owner: current_task_owner.email
            }
          });
        } else {
          dispatch(getClaimTask(id, history, assignee, current_task_owner, claimFailTaskRefreshHandler))
        }
      })
      .catch(() => {
        dispatch(getClaimTask(id, history, assignee, current_task_owner, claimFailTaskRefreshHandler))
        clientLogger.log({
          message: {
            error: "This task is already completed or claimed by other user.",
            taskID: id,
            url: window.location.href,
            assignee: assignee,
            current_task_owner: current_task_owner.email
          }
        });
      })
  }
}
